<template>
  <div>
    <el-card>
      <div slot="header" class="clearfix">
        <span style="color: #409EFF">收费标准</span>
      </div>
      <el-tabs class="el-tabs-self" v-model="tabsActive" @change="menuChanged">
        <el-tab-pane v-for="(item, index) in tabsActives" :key="index" :label="item.taskName" :name="item.id+''"></el-tab-pane>
      </el-tabs>
      <price-standard-component :dataSelectParam="selectMenuValue"></price-standard-component>
    </el-card>
  </div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD';
import PriceStandardComponent from './PriceStandardComponent'
import {getAllTaskType} from "../../api/b2cbusiness/b2c_tasktype";
export default {
  name: "PriceStandardlist",
  mixins: [MixinCUD],
  components: {
    PriceStandardComponent
  },
  data() {
    return {
      tabsActive: "1",
      tabsActives: []
    }
  },
  mounted() {
    getAllTaskType().then(res => {
      this.tabsActives = res.data;
    });
  },
  computed: {
    selectMenuValue(){
      return this.tabsActives.find(item=>item.id == this.tabsActive);
    }
  },
  methods:{
    menuChanged(val){
      this.tabsActive = val
    }
  }
}
</script>

<style scoped>
.el-form {
  margin-top: 20px;
}

.el-tabs-self{
  position: relative;
  width: 100%;
}
</style>
